var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 9.09536C5.625 8.94586 5.68426 8.80249 5.78975 8.69678C5.89524 8.59108 6.03832 8.53169 6.1875 8.53169H11.25V4.86785C11.25 3.74052 10.0621 2.89502 9 2.89502H3.65625C3.13428 2.89558 2.63384 3.10361 2.26475 3.47347C1.89566 3.84332 1.68806 4.3448 1.6875 4.86785V13.3229C1.68806 13.8459 1.89566 14.3474 2.26475 14.7172C2.63384 15.0871 3.13428 15.2951 3.65625 15.2957H9.28125C9.80322 15.2951 10.3037 15.0871 10.6728 14.7172C11.0418 14.3474 11.2494 13.8459 11.25 13.3229V9.65902H6.1875C6.03832 9.65902 5.89524 9.59964 5.78975 9.49393C5.68426 9.38822 5.625 9.24485 5.625 9.09536Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1476 8.69687L13.3351 5.87853C13.2288 5.77729 13.0872 5.72168 12.9405 5.72356C12.7938 5.72544 12.6537 5.78466 12.5499 5.88861C12.4462 5.99255 12.3871 6.13298 12.3852 6.27996C12.3834 6.42694 12.4388 6.56885 12.5399 6.67542L14.3919 8.53164H11.25V9.65898H14.3919L12.5399 11.5152C12.4855 11.567 12.4419 11.6292 12.4119 11.6982C12.3818 11.7671 12.3658 11.8414 12.3649 11.9166C12.3639 11.9919 12.378 12.0665 12.4063 12.1362C12.4346 12.2059 12.4765 12.2692 12.5296 12.3224C12.5827 12.3756 12.6458 12.4176 12.7154 12.446C12.7849 12.4743 12.8594 12.4884 12.9345 12.4875C13.0096 12.4865 13.0837 12.4705 13.1525 12.4404C13.2213 12.4102 13.2834 12.3666 13.3351 12.3121L16.1476 9.49375C16.253 9.38805 16.3122 9.24474 16.3122 9.09531C16.3122 8.94588 16.253 8.80256 16.1476 8.69687Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.daf7b03fd4582780dad129a1443aba85.svg";
export { ForwardRef as ReactComponent };